import { createFeature, createReducer, on } from '@ngrx/store';
import { PermissionsActions } from './premissions.actions';
import { PermissionModels } from '@share-models';

export type PermissionsState = PermissionModels.UserPermissionsState;

export const initialState: PermissionsState = {
  permissions: [],
  entityIds: [],
};

export const permissionsStateReducer = createReducer(
  initialState,
  on(PermissionsActions.resetToInitialState, () => {
    return {
      ...initialState,
    };
  }),
  on(
    PermissionsActions.getUserPermissionsSuccess,
    (state, { entityIds, permissions }) => {
      return {
        ...state,
        entityIds,
        permissions,
      };
    },
  ),
);

export const permissionsFeature = createFeature({
  name: 'permissions',
  reducer: permissionsStateReducer,
});
